// extracted by mini-css-extract-plugin
export default {"container":"checkbox_container__YnbF+","checkmark":"checkbox_checkmark__ffi+K"};